import React from 'react';

export default function ImageComponent({sourceUrl, details, width, height}) {
    return (
        <img src={sourceUrl} alt={details} width={width} height={height} style={{marginRight: '5px', marginLeft: '5px'}} />
    )
}